import { render, staticRenderFns } from "./DkimVerificationAlert.vue?vue&type=template&id=6ddeceea&scoped=true"
import script from "./DkimVerificationAlert.vue?vue&type=script&lang=js"
export * from "./DkimVerificationAlert.vue?vue&type=script&lang=js"
import style0 from "./DkimVerificationAlert.vue?vue&type=style&index=0&id=6ddeceea&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddeceea",
  null
  
)

export default component.exports